
import { useEffect, useState } from 'react';
import { getUserPermissions } from '../../utils/admins';
import { handleSendNotification, deleteScheduledNotification } from './PushNotification.services';
import { Input, Modal } from '../../components';
import store from '../../utils/store'
import 'rc-time-picker/assets/index.css';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import moment from 'moment';
import locale from 'date-fns/locale/fr/index.js';
import { Grid } from '@material-ui/core';
export function PushNotifModal({ stateObj, setStateObj, openErrorModal }) {
  const { shopId, nbShops, isAllShops } = store.getState().user;
  const [isShopAdmin, setIsShopAdmin] = useState(false);
  const isAdminOfOneShop = nbShops === 1 && !isShopAdmin;
  const parsedDate = moment().toDate();
  const extractedTime = parsedDate.toTimeString().slice(0, 5);
  const [selectedDate, setSelectedDate] = useState(parsedDate);
  const [selectedTime, setSelectedTime] = useState(extractedTime);
  useEffect(() => {
    (async () => {
      const { isAdminOfThisShop } = await getUserPermissions(shopId);
      setIsShopAdmin(isAdminOfThisShop)
    })()
  }, [shopId])
  useEffect(() => {
    if (stateObj?.pushNotif?.scheduledDate) {
      const newParsedDate = moment(stateObj.pushNotif.scheduledDate).toDate();
      const newExtractedTime = moment(stateObj.pushNotif.scheduledDate).format('HH:mm');
      setSelectedDate(newParsedDate);
      setSelectedTime(newExtractedTime);
    }
    else {
      setSelectedDate(moment().toDate());
      setSelectedTime(moment().toDate().toTimeString().slice(0, 5));
    }
  }, [stateObj?.pushNotif?.scheduledDate, moment().toDate().toTimeString().slice(0, 5)]);
  return <Modal
    size="lg"
    showCancelBtn
    header
    isOpen={stateObj.modalOpen}
    title={`Push Notification ${stateObj.isSchedule ? 'programmée' : ''}`}
    onClick={() => handleSendNotification(stateObj, setStateObj, selectedDate, selectedTime, isAdminOfOneShop, openErrorModal, isAllShops)}
    btnTxt={stateObj.isSchedule ? 'Enregistrer' : 'Envoyer'}
    handleClose={() => {
      setStateObj({ modalOpen: false, pushNotif: {} });
      setSelectedDate(moment().toDate());
      setSelectedTime(moment().toDate().toTimeString().slice(0, 5));
    }}
    loading={stateObj.isLoadingModal}
    showDeleteBtn={stateObj?.pushNotif?.scheduledDate && !stateObj.createPushNotif}
    handleDelete={() => {
      deleteScheduledNotification(stateObj, setStateObj, openErrorModal)
    }}
    btnDeleteTxt='Supprimer'
  >
    <>
      <div>
        <h5 className="pb-2">
          {`Envoi d'une nouvelle Push notification ${stateObj.isSchedule ? 'programmée' : ''} à ${isAllShops ? 'tous' : ''} vos utilisateurs`}
        </h5>
        <Input
          autoFocus
          margin="dense"
          id="Title"
          maxLength={40}
          label="Titre de la notification"
          type="text"
          value={stateObj?.pushNotif?.title}
          onChange={e => setStateObj({ pushNotif: { ...stateObj.pushNotif, title: e.target.value } })}
          fullWidth
        />
        <Input
          margin="dense"
          multiline
          rows="2"
          id="Message"
          maxLength={160}
          label="Message de la notification"
          type="text"
          value={stateObj?.pushNotif?.message}
          onChange={e => setStateObj({ pushNotif: { ...stateObj.pushNotif, message: e.target.value } })}
          fullWidth
        />
        {(stateObj?.pushNotif?.scheduledDate || stateObj.isSchedule) &&

          <Grid
            container
            spacing={1}
            alignItems="center"
            justifyContent="space-between"
            className='pt-2'
          >
            <Grid item xs="auto" sm="auto" md="auto">
              <h5>Programmer l'envoi le</h5>
            </Grid>
            <Grid item sm={5} md={5} lg={5}>
              <DatePicker
                dateFormat="dd MMMM yyyy"
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                locale={locale}
                customInput={
                  <Input
                    value={selectedDate.toLocaleDateString('fr-FR')}
                    InputProps={{
                      endAdornment: <ArrowDropDownIcon />,
                    }}
                    style={{
                      width: '100%',
                      fontSize: '14px',
                    }}
                  />
                }
                min={moment().toDate()}
              />
            </Grid>

            <Grid item xs="auto" sm="auto" md="auto">
              <h5 >à</h5>
            </Grid>
            <Grid item xs="auto" sm="auto" md="auto" lg="auto">
              <Input
                type="time"
                value={selectedTime}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(event) => { setSelectedTime(event.target.value) }}
                style={{
                  width: '100%',
                  fontSize: '14px',
                }}
              />
            </Grid>
          </Grid>
        }


      </div>
    </>
  </Modal>
}